<template>
	<div>
		<VideoList
			:title="$I18n.trans('arena.video_center.title')"
			:enable-filter-sport="enableFilterSportComputed"
			:sports="sports"
			:enable-filter-date="enableFilterDateComputed"
			:content-period="contentPeriod"
			:enable-filter-team-category="enableFilterTeamCategoryComputed"
			:use-division-as-team-category-label="useDivisionAsTeamCategoryLabel"
			:team-categories="teamCategories"
			:enable-filter-team="enableFilterTeamComputed"
			:teams="teams"
			:context-filter="contextFilter"
			:event-filters="eventFilters"
			:external-sort-order="sortOrder"
			:hide-filters="hideFilters"
			:show-results-count="true"
		/>
	</div>
</template>

<script>
import VideoList from './VideoList';

export default {
	name:       'VideoCenter',
	components: { VideoList },
	props:      {
		contextFilter: {
			type:     Object,
			required: true,
		},
		eventFilters: {
			type:    Object,
			default: () => ({}),
		},
		sortOrder: {
			type:    Object,
			default: () => ({}),
		},
		sports: {
			type:    Array,
			default: () => [],
		},
		contentPeriod: {
			type:    Array,
			default: () => [],
		},
		enableFilterSport: {
			type:    Boolean,
			default: true,
		},
		enableFilterDate: {
			type:    Boolean,
			default: true,
		},
		enableFilterTeamCategory: {
			type:    Boolean,
			default: false,
		},
		enableFilterTeam: {
			type:    Boolean,
			default: false,
		},
		teamCategories: {
			type:    Array,
			default: () => [],
		},
		teams: {
			type:    Array,
			default: () => [],
		},
		hideFilters: {
			type:    Boolean,
			default: true,
		},
	},
	computed: {
		enableFilterSportComputed() {
			return this.enableFilterSport && (this.sports?.length > 1);
		},
		enableFilterDateComputed() {
			return this.enableFilterDate && (this.contentPeriod?.length > 1);
		},
		enableFilterTeamCategoryComputed() {
			return this.enableFilterTeamCategory && (this.teamCategories?.length > 1);
		},
		enableFilterTeamComputed() {
			return this.enableFilterTeam && (this.teams?.length > 1);
		},
		useDivisionAsTeamCategoryLabel() {
			return this.$arenaConfig.isEuf;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

</style>
